import React from 'react'

function FooterLogin () {
    return (
        <div className="footer-login">
            <span className="ng-scope">Diseñado y desarrollado por</span>
            <div className="partners">
                <img src="assets/img/logo-trie.png" alt="Logo Trie" height="50px" />
                <img src="assets/img/logo-trie-compu.png" alt="Logo Trie Programacion" height="45px" />
            </div>
        </div>
    );
}

export default FooterLogin;


// WEBPACK FOOTER //
// ./src/components/layout/footerLogin.js